import { SVG } from '../../types/svg'

export const ExitDoor = (props: SVG) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0"
    y="0"
    enableBackground="new 0 0 480 480"
    version="1.1"
    viewBox="0 0 480 480"
    xmlSpace="preserve"
    {...props}
  >
    <path d="M264 468h208V4H264v120" />
    <path d="M277.896 234.656c-4.796-9.832-16.654-13.915-26.487-9.12l-.209.104-35.28 17.864-2.264.176-19.904-33.6c25.877.228 47.039-20.564 47.268-46.441s-20.564-47.039-46.441-47.268-47.039 20.564-47.268 46.441a46.856 46.856 0 0012.905 32.708l-12.904-5.6-66.848 28.216a20.09 20.09 0 00-12.16 13.928l-13.272 53.76c-2.703 10.743 3.76 21.656 14.48 24.448 10.649 2.654 21.434-3.827 24.088-14.476l.048-.196 10.76-43.6 36.272-15.048-13.264 73.92-47.344 53.048-39.064-34.616c-8.13-7.24-20.59-6.52-27.83 1.61-.084.094-.167.19-.25.286-7.24 8.406-6.407 21.063 1.872 28.448l53.072 47.04c7.859 7.002 19.832 6.597 27.2-.92l55.328-56.072 48.048 29.208 30.576 61.944A19.88 19.88 0 00246.84 452a19.613 19.613 0 008.888-2.136c9.856-5.072 13.82-17.113 8.904-27.048l-33.176-67.2a20.118 20.118 0 00-7.56-8.272l-54.04-32.8L181.12 263.2l8.096 16.408a19.895 19.895 0 0017.816 11.152 19.587 19.587 0 008.888-2.136l53.072-26.88c9.883-5.07 13.851-17.144 8.904-27.088z" />
    <path
      fill="#F2F2F2"
      d="M423.384 247.056a8 8 0 000-6.112 7.911 7.911 0 00-1.736-2.608l-32-32a8 8 0 00-11.312 11.312L396.688 236H312a8 8 0 000 16h84.688l-18.344 18.344a8 8 0 00-.196 11.312 8 8 0 0011.508 0l32-32a7.913 7.913 0 001.728-2.6z"
    />
    <path fill="#333" d="M472 476H8a8 8 0 010-16h464a8 8 0 010 16z" />
  </svg>
)

export default ExitDoor
